import { useState } from "react";
import "./PageHeader.scss";
import FS_LOGO_BLANCO from "../../../assets/img/FS-LOGO-BLANCO.svg";
import FS_BANNER_TELEFONO from "../../../assets/img/FS-HOME-BANNER-PRINCIPAL-TELEFONO.png";
import g_evolution_logo_text from "../../../assets/img/g_evolution_logo_text.png";
import Logo from "../../Atoms/Logo/Logo";
import NavMenu from "../../Organisms/NavMenu/NavMenu";
import LowSize_HeaderBg from "../../../assets/img/LowSize_HeaderBg.jpg";
import HamburgerMenuSvg from "../../Atoms/HamburgerMenuSvg/HamburgerMenuSvg";
import CloseSvg from "../../Atoms/CloseSvg/CloseSvg";
import ResponsiveNavMenu from "../../Organisms/ResponsiveNavMenu/ResponsiveNavMenu";
import { Carousel } from "react-responsive-carousel";
import BannerContent from "../../Atoms/BannerContent/BannerContent";
import useGetSliders from "../../../hooks/useGetSliders";
import Loader from "../../Atoms/Loader/Loader";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "../../Pages/Home/content";

const PageHeader = ({
	route = "van-header",
	withTitle,
	withBanner,
	titleBanner,
	spanTitleYellow,
	animate,
	moveAnimation,
	hideVisibility,
	changeableHeader,
	gEvolution
}) => {
	const [showResponsiveMenu, setShowResponsiveMenu] = useState(false);
	const { loading, sliders } = useGetSliders(withBanner);
	const { language } = useLanguageCtx();

	return (
		<header
			className={`page-header ${withBanner && "banner"}  ${
				withTitle && "title"
			} ${route} ${showResponsiveMenu && "showing-responsive-menu"} ${
				animate && "animate"
			} ${hideVisibility && "hide-visibility"} ${
				moveAnimation && moveAnimation
			} ${changeableHeader && "changeable-header"}`}
		>
			{withTitle && !animate && (
				<img
					src={LowSize_HeaderBg}
					alt="background"
					className="pageHeader--low_size_img all-width-height aspect-ratio cover"
				/>
			)}

			<div className="max-width page-header--container">
				<Logo url={FS_LOGO_BLANCO} />
				<div className="toggleMenu--container">
					{!showResponsiveMenu ? (
						<HamburgerMenuSvg setShowResponsiveMenu={setShowResponsiveMenu} />
					) : (
						<CloseSvg clickHandler={() => setShowResponsiveMenu(false)} />
					)}
					{showResponsiveMenu && <ResponsiveNavMenu />}
				</div>
				<NavMenu />
			</div>
			{withBanner && (
				<div className="pageHeader--carousel-container">
					<Carousel
						autoPlay={true}
						showStatus={false}
						infiniteLoop={true}
						interval="3500"
						showThumbs={false}
						className="pageHeader--carousel"
					>
						<BannerContent
							title={content[language].bannerTitle}
							yellowTitle={content[language].bannerYellowSpan}
							boldText={content[language].bannerBoldText}
							buttonContent={content[language].bannerButtonContent}
							img={{ src: FS_BANNER_TELEFONO, alt: "FS_BANNER_TELEFONO" }}
						/>
						{loading ? (
							<Loader allHeight />
						) : (
							sliders.map((slider) => (
								<BannerContent
									key={slider.slug}
									title={slider.titulo_esp}
									yellowTitle={slider.titulocomplemento_esp}
									boldText={slider.info_esp}
									buttonContent={slider.textoboton_esp}
									img={{
										src: slider.multimedia[0].url,
										alt: slider.multimedia[0].name,
									}}
								/>
							))
						)}
					</Carousel>
				</div>
			)}
			{withTitle && (
				<div className="page-header--title-container">
					<div className="max-width page-header--title">
						{!gEvolution ? (
							<div className="center-text">
								<h1 className="t1 c-white title-transition">
									{titleBanner}
									<span className="t1 c-yellow title-transition">
										{spanTitleYellow}
									</span>
								</h1>
							</div>
						) : (
							<div className="flex center-content-items">
								<img
									src={g_evolution_logo_text}
									alt="G EVOLUTION"
									className="page-header--gEvolutionImg title-transition aspect-ratio contain "
								/>
							</div>
						)}
					</div>
				</div>
			)}
		</header>
	);
};

export default PageHeader;
